import { render, staticRenderFns } from "./EditSpj.vue?vue&type=template&id=766dab65&"
import script from "./EditSpj.vue?vue&type=script&lang=js&"
export * from "./EditSpj.vue?vue&type=script&lang=js&"
import style0 from "./EditSpj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports